// extracted by mini-css-extract-plugin
export default {"container":"trail_container__TM9Cz","box":"trail_box__Mz+ua","box_front":"trail_box_front__qM8YR","box_back":"trail_box_back__-486h"};